module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_Black.d4e2be8b.jpg";